'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';

const getExchangeRates = () => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        ETH: 3447.28,
        MATIC: 0.5207,
        SOL: 217.37,
        USDC: 1,
    });
});

export { getExchangeRates };
